module.exports = "<ticket-list customer=\"pvm.customer\" extra-fields=\"['fields']\"></ticket-list>\n<div id=\"create-button\"\n    data-testid=\"ticket-create-button\"\n    class=\"bottom-right-icon-button\"\n    permission permission-only=\"'main.add_ticket'\">\n    <div class=\"btn btn-primary btn-fab\"\n        role=\"button\"\n        title=\"Create new ticket\"\n        aria-label=\"Create new ticket\"\n        ng-click=\"vm.create()\">\n            <i class=\"btn-icon fa fa-plus\" aria-hidden=\"true\"></i>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/customers/ticket.list.html
// module id = 713
// module chunks = 0